import { physicalDto } from '../dto/physicalDto';
import { tableViewModel } from '../views/tableViewModel';

export class physicalHostsStatsTransformer {
  public static from(physicalHostsStatsData: physicalDto): tableViewModel[] {
    return <tableViewModel[]>[
      {
        name: 'Cores',
        value:
          physicalHostsStatsData.hostCoreCount == null ? '-' : physicalHostsStatsData.hostCoreCount
      },
      {
        name: 'Memory',
        value:
          physicalHostsStatsData.hostMemory == null
            ? '-'
            : (physicalHostsStatsData.hostMemory).toFixed(2) + ' GiB'
      },
      {
        name: 'Capacity',
        value:
          physicalHostsStatsData.hostDiskCapacity == null
            ? '-'
            : (physicalHostsStatsData.hostDiskCapacity).toFixed(2) + ' GiB'
      }
    ];
  }
}
